import { render, staticRenderFns } from "./configList.vue?vue&type=template&id=03bcb076&"
import script from "./configList.vue?vue&type=script&lang=js&"
export * from "./configList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03bcb076')) {
      api.createRecord('03bcb076', component.options)
    } else {
      api.reload('03bcb076', component.options)
    }
    module.hot.accept("./configList.vue?vue&type=template&id=03bcb076&", function () {
      api.rerender('03bcb076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/performancecenter/theaterManage/configList.vue"
export default component.exports